<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Branch Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                v-bind:search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', 'branch')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', 'branch')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    brn: String
  },
  data() {
    return {
      headers: [
        { text: 'Branch', value: 'branch' },
        { text: 'Description', value: 'brnDesc' }
      ],
      selected: [],
      branches: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    menu: function () {
      this.doInit()
    }
  },
  methods: {
    async doInit() {
      if (this.brn !== null && this.brn !== '' && this.brn !== undefined) {
        this.branches = this.brn.split(',')
      }
      const apiURI = this.menu.branchList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            this.selectedItems = []
            const data = result.data.branchList
            if (data) {
              data.map((brnList) => {
                const convertList = {
                  key: brnList.value,
                  branch: brnList.value,
                  brnDesc: brnList.label
                }
                if (this.checkedItems.includes(brnList.branch)) {
                  const branchList = {
                    key: brnList.value,
                    branch: brnList.value,
                    brnDesc: brnList.label
                  }
                  this.selectedItems.push(branchList)
                }
                this.items.push(convertList)
              })
            }
            if (this.checkedItems.toString() === 'All') {
              this.doReset()
              this.toggleAll()
            } else {
              this.toggleSelected()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>
